import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Subject } from 'rxjs';
import {
  AuthorizationService,
  InitService,
  WebsocketService,
} from '@infodata-group/inf-commons';

export const customAuthorizationGuard: CanActivateFn = () => {
  const initService = inject(InitService);
  const authorizationService = inject(AuthorizationService);
  const websocketService = inject(WebsocketService);

  if (initService.isLoaded && authorizationService.userContext) {
    websocketService.connect(authorizationService.userContext.witoken);
    return true;
  }

  const emitter$ = new Subject<boolean>();
  initService.isConfigLoaded.subscribe((result) => {
    if (result) {
      initService.isLoaded$.subscribe((res) => {
        if (res && authorizationService.userContext) {
          websocketService.connect(authorizationService.userContext.witoken);
          emitter$.next(true);
        }
        if (res && !authorizationService.userContext) {
          emitter$.next(false);
          authorizationService.logout();
        }
      });
      authorizationService.init();
    }
  });
  return emitter$;
};
